document.addEventListener("DOMContentLoaded", function () {
if (!window.location.pathname.includes("/cart")) {
    const cartDrawer = document.getElementById("cart-drawer");
    const closeCartBtn = document.getElementById("close-cart");
    const cartItemsContainer = document.getElementById("cart-items");
    const cartSubtotal = document.getElementById("cart-subtotal");
    const body = document.body;
    const overlay = document.querySelector(".cart-overlay");
    const cartIcon = document.querySelector(".cart-icon");
    const cartIcon2 = document.querySelector(".cart-icon-sticky");

    // Escapes a value for safe interpolation inside an HTML attribute
    // (e.g. aria-label="..."), since product/variant titles come from
    // merchant-entered data and could contain quotes or angle brackets.
    function escapeHtmlAttr(value) {
        return String(value == null ? "" : value)
            .replace(/&/g, "&amp;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");
    }

    // Reveals the drawer to assistive tech / keyboard tab order and moves
    // focus into it. Captures the currently-focused element first (the cart
    // icon or add-to-cart button the user just activated) so closeCartDrawer
    // can restore focus there. Shared with cartdrawer.liquid's own
    // window.closeCartDrawer via the window.__cartDrawerLastFocused global.
    function revealCartDrawerA11y() {
        window.__cartDrawerLastFocused = document.activeElement;
        cartDrawer.removeAttribute("aria-hidden");
        cartDrawer.removeAttribute("inert");
        if (closeCartBtn) closeCartBtn.focus();
    }

    function openCartDrawer() {
        // Used by cart icon clicks — fetches fresh data then opens
        updateCart().then(() => {
            cartDrawer.classList.add("open");
            body.classList.add("no-scroll");
            revealCartDrawerA11y();
        });
    }

    function openCartDrawerNow() {
        // Used after add-to-cart — data already fresh, open immediately
        cartDrawer.classList.add("open");
        body.classList.add("no-scroll");
        revealCartDrawerA11y();
    }

    function closeCartDrawer() {
        cartDrawer.classList.remove("open");
        body.classList.remove("no-scroll");
        cartDrawer.setAttribute("aria-hidden", "true");
        cartDrawer.setAttribute("inert", "");
        if (window.__cartDrawerLastFocused && typeof window.__cartDrawerLastFocused.focus === "function") {
            window.__cartDrawerLastFocused.focus();
        }
        window.__cartDrawerLastFocused = null;
    }

    async function updateCart() {
        try {
            let response = await fetch("/cart.js");
            let cart = await response.json();
            let totalItems = 0;

            const cartTotalItems = document.getElementById("cart-total-items");
            const headerCartItems = document.getElementById("header-cart-total-items");
            const headerCartItemsSticky = document.getElementById("header-cart-total-items-sticky");

            if (cart.items && cart.items.length > 0) {
                let cartContent = "";
                cart.items.forEach(item => {
                    totalItems += item.quantity;

                    let itemTotalPrice = (item.final_line_price / 100).toFixed(2);
                    let variantInfo = '';
                    if (item.variant_title && item.variant_title !== 'Default Title') {
                        variantInfo = `<span class="cart-item-variant">(${item.variant_title})</span>`;
                    }

                    let subscriptionInfo = '';
                    if (item.selling_plan_allocation) {
                        subscriptionInfo = `
                            <span class="cart-item-subscriptions">
                                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="vertical-align:middle;margin-right:3px;">
                                    <path d="M23 4v6h-6M1 20v-6h6"/>
                                    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
                                </svg>
                                ${item.selling_plan_allocation.selling_plan.name}
                            </span>`;
                    }

                    // Accessible name for this item's per-row controls (quantity buttons,
                    // quantity input, remove button) — escaped since product_title is
                    // interpolated into HTML attributes below.
                    const itemLabel = escapeHtmlAttr(item.product_title);

                    cartContent += `
                        <div class="cart-item" data-key="${item.key}">
                            <img src="${item.image}" alt="${item.product_title}">
                            <div class="cart-item-info">
                                <p>${item.product_title}</p>
                                ${variantInfo}
                                ${subscriptionInfo}
                                <div class="main-bottom">
                                <div class="cart-item-quantity">
                                    <button class="decrease" data-key="${item.key}" aria-label="Decrease quantity of ${itemLabel}">-</button>
                                    <input type="text" class="quantity-input" value="${item.quantity}" data-key="${item.key}" aria-label="Quantity of ${itemLabel}" />
                                    <button class="increase" data-key="${item.key}" aria-label="Increase quantity of ${itemLabel}">+</button>
                                </div>
                                <p class="cart-item-price">$${itemTotalPrice}</p>
                                </div>
                            </div>
                            <button class="remove-item" data-key="${item.key}" aria-label="Remove ${itemLabel} from cart">×</button>
                        </div>`;
                });

                cartItemsContainer.innerHTML = cartContent;
                cartSubtotal.textContent = `$${(cart.total_price / 100).toFixed(2)}`;

                if (cartTotalItems) cartTotalItems.textContent = totalItems;
                if (headerCartItems) headerCartItems.textContent = totalItems;
                if (headerCartItemsSticky) headerCartItemsSticky.textContent = totalItems;

            } else {
                cartItemsContainer.innerHTML = `
                    <div class="empty-cart">
                        <p>Your cart is empty.</p>
                        <a href="/collections/or-bestsellers" class="shop-now-button">Shop Now</a>
                    </div>`;
                cartSubtotal.textContent = "$0.00";

                if (cartTotalItems) cartTotalItems.textContent = "0";
                if (headerCartItems) headerCartItems.textContent = "0";
                if (headerCartItemsSticky) headerCartItemsSticky.textContent = "0";
            }

            updateCartDrawerVisibility();

        } catch (error) {
            console.error("Error fetching cart:", error);
        }
    }

    async function updateItemQuantity(key, quantity, button = null) {
        if (quantity < 1) return;
        if (button) toggleLoadingState(button, true);
        const itemPriceEl = document.querySelector(`.cart-item[data-key="${key}"] .cart-item-price`);
        if (window.cartDrawerSetPriceLoading) window.cartDrawerSetPriceLoading(true, itemPriceEl);
        try {
            await fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: key, quantity }),
            });
            if (button) toggleLoadingState(button, false);
            await updateCart();
        } finally {
            if (window.cartDrawerSetPriceLoading) window.cartDrawerSetPriceLoading(false, itemPriceEl);
        }
    }

    async function removeCartItem(key, button) {
        toggleLoadingState(button, true);
        if (window.cartDrawerSetPriceLoading) window.cartDrawerSetPriceLoading(true);
        try {
            await fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: key, quantity: 0 }),
            });
            toggleLoadingState(button, false);
            await updateCart();
        } finally {
            if (window.cartDrawerSetPriceLoading) window.cartDrawerSetPriceLoading(false);
        }
    }

    function toggleLoadingState(button, isLoading) {
        if (isLoading) {
            button.dataset.originalContent = button.innerHTML;
            button.innerHTML = `<div class='cart-spinner'></div>`;
            button.disabled = true;
        } else {
            button.innerHTML = button.dataset.originalContent;
            button.disabled = false;
        }
    }

    cartItemsContainer.addEventListener("click", (event) => {
        const button = event.target;
        const key = button.getAttribute("data-key");

        if (button.classList.contains("increase")) {
            let input = button.previousElementSibling;
            let newQuantity = parseInt(input.value) + 1;
            input.value = newQuantity;
            updateItemQuantity(key, newQuantity, button);
        }
        if (button.classList.contains("decrease")) {
            let input = button.nextElementSibling;
            let newQuantity = Math.max(1, parseInt(input.value) - 1);
            input.value = newQuantity;
            updateItemQuantity(key, newQuantity, button);
        }
        if (button.classList.contains("remove-item")) {
            const itemEl = button.closest(".cart-item");
            if (itemEl && window.cartDrawerAnimateRemoval) {
                window.cartDrawerAnimateRemoval(itemEl, () => removeCartItem(key, button));
            } else {
                removeCartItem(key, button);
            }
        }
    });

    cartItemsContainer.addEventListener("focusout", (event) => {
        if (event.target.classList.contains("quantity-input")) {
            const key = event.target.getAttribute("data-key");
            const quantity = parseInt(event.target.value) || 1;
            updateItemQuantity(key, quantity);
        }
    });

// ─── PRODUCT PAGE ADD TO CART ────────────────────────────────────────────
// We intercept the button CLICK before the form submit fires.
// This prevents the theme's Product.updateCart from ever running.
document.addEventListener('click', async function(e) {
    const btn = e.target.closest('button[type="submit"], input[type="submit"], .add-to-cart');
    if (!btn) return;

    const productForm = btn.closest('form[action$="/cart/add"]');
    if (!productForm) return;

    // Skip upsell forms — handled separately
    if (productForm.closest('.upsell-variant-form')) return;
    // Skip collection buttons — handled by the .add-to-cart click handler below
    if (btn.getAttribute('data-id')) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const variantInput = productForm.querySelector('[name="id"], [name="variant_id"]');
    const quantityInput = productForm.querySelector('[name="quantity"]');
    const submitBtn = btn;

    const variantId = variantInput ? variantInput.value : null;
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    if (!variantId) {
        console.error("No variant ID found in form — cannot add to cart");
        return;
    }

    toggleLoadingState(submitBtn, true);

    try {
        // Send the whole form so selling_plan (subscriptions) and
        // properties[...] (e.g. Orchid Notes) reach the cart. Disabled
        // fields are skipped by FormData, so one-time purchases send no plan.
        const formData = new FormData(productForm);
        formData.set('id', variantId);
        formData.set('quantity', quantity);

        const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
        });

        if (!res.ok) {
            const err = await res.json();
            console.error("Add to cart failed:", err);
            return;
        }

        await updateCart();
        openCartDrawerNow();
    } catch (err) {
        console.error("Add to cart error:", err);
    } finally {
        toggleLoadingState(submitBtn, false);
    }
}, true); // capture phase on CLICK — fires before theme can submit the form

    // ─── COLLECTION PAGE ADD TO CART (standalone buttons with data-id) ───────
    // These are buttons outside a product form that carry data-id directly.
    document.querySelectorAll(".add-to-cart").forEach(button => {
        // Skip submit buttons inside product forms — handled above
        if (button.closest('form[action$="/cart/add"]')) return;

        button.addEventListener("click", async function (event) {
            event.preventDefault();
            event.stopPropagation();

            const productId = this.getAttribute("data-id");
            if (!productId) {
                console.error("No data-id on button — skipping");
                return;
            }

            toggleLoadingState(this, true);

            try {
                await fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: productId, quantity: 1 }),
                });
                await updateCart();
                openCartDrawerNow();
            } catch (err) {
                console.error("Add to cart error:", err);
            } finally {
                toggleLoadingState(this, false);
            }
        });
    });

    closeCartBtn.addEventListener("click", closeCartDrawer);

    document.addEventListener("click", function (event) {
        if (
            !cartDrawer.contains(event.target) &&
            !event.target.closest(".add-to-cart") &&
            !event.target.closest(".cart-overlay") &&
            !event.target.closest(".flatpickr-calendar")
        ) {
            closeCartDrawer();
        }
    });

    overlay.addEventListener("click", closeCartDrawer);

    cartIcon.addEventListener("click", () => {
        openCartDrawer();
    });
    cartIcon2.addEventListener("click", () => {
        openCartDrawer();
    });

    // ─── UPSELL FORMS ────────────────────────────────────────────────────────
    function renderRandomUpsells() {
        const pool = document.querySelectorAll("#upsell-pool .upsell-item");
        const target = document.querySelector("#upsell-target .upsell-items");
        if (!pool.length || !target) return;
        const shuffled = Array.from(pool).sort(() => 0.5 - Math.random()).slice(0, 3);
        target.innerHTML = "";
        shuffled.forEach(item => target.appendChild(item.cloneNode(true)));
    }

    document.addEventListener("submit", async function (e) {
        const form = e.target.closest(".upsell-variant-form");
        if (!form) return;

        e.preventDefault();

        const select = form.querySelector(".upsell-variant-select");
        const hiddenInput = form.querySelector(".upsell-single-variant-id");
        const variantId = select ? select.value : hiddenInput ? hiddenInput.value : null;
        const button = form.querySelector("button");

        if (!variantId) return;

        button.disabled = true;
        button.textContent = "Adding...";

        try {
            const res = await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({ id: variantId, quantity: 1 })
            });
            if (!res.ok) throw new Error("Add to cart failed");
            button.textContent = "Added!";
            await updateCart();
            openCartDrawerNow();
            renderRandomUpsells();
        } catch (err) {
            console.error("Upsell add error:", err);
            button.textContent = "Error";
        } finally {
            setTimeout(() => {
                button.disabled = false;
                button.textContent = "Add to Cart";
            }, 1000);
        }
    });

    renderRandomUpsells();

    document.addEventListener("change", function (e) {
        if (e.target.classList.contains("upsell-variant-select")) {
            const select = e.target;
            const selectedOption = select.options[select.selectedIndex];
            const wrapper = select.closest(".upsell-details");
            const priceEl = wrapper ? wrapper.querySelector(".variant-price") : null;
            const comparePriceEl = wrapper ? wrapper.querySelector(".compare-price") : null;
            const price = selectedOption.dataset.price;
            const compareAt = selectedOption.dataset.compareAtPrice;
            if (priceEl) priceEl.textContent = `$${price}`;
            if (comparePriceEl) {
                comparePriceEl.style.display = compareAt ? "inline-block" : "none";
                if (compareAt) comparePriceEl.textContent = `$${compareAt}`;
            }
        }
    });

    // ─── CART DRAWER VISIBILITY ───────────────────────────────────────────────
    function updateCartDrawerVisibility() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const midContainer = document.querySelector('.cart-drawer__mid-container');
                const footer = document.querySelector('.cart-drawer__footer');
                if (cart.item_count === 0) {
                    if (midContainer) midContainer.style.display = 'none';
                    if (footer) footer.style.display = 'none';
                } else {
                    if (midContainer) midContainer.style.display = 'block';
                    if (footer) footer.style.display = 'block';
                }
            });
    }

    updateCartDrawerVisibility();
    document.addEventListener("cart:updated", updateCartDrawerVisibility);

    // ─── AJAXINATE ────────────────────────────────────────────────────────────
    if (document.getElementById('AjaxinateContainer')) {
        var ajaxinate = new Ajaxinate({
            container: '#AjaxinateContainer .collection-products',
            pagination: '#AjaxinatePagination',
            method: 'scroll',
            callback: function () {
                if (window.theme && window.theme.rimg && typeof window.theme.rimg.update === 'function') {
                    window.theme.rimg.update();
                } else {
                    document.querySelectorAll('[data-rimg-template]').forEach(el => {
                        const size = el.dataset.rimgMax || '600x600';
                        if (el.dataset.rimgTemplate) {
                            const imageUrl = el.dataset.rimgTemplate.replace('{size}', size);
                            if (el.tagName.toLowerCase() === 'img') {
                                el.srcset = imageUrl + ' 1x';
                            } else {
                                el.style.backgroundImage = `url('${imageUrl}')`;
                            }
                        }
                    });
                }
                bindAddToCartButtons();
                bindVariantForms();
                forceSelectWrapper();
                bindVariantSelectChange();
            }
        });
    }

    bindAddToCartButtons();
    bindVariantForms();
    console.log("Variant form handlers initialized");
    forceSelectWrapper();
    bindVariantSelectChange();

    function bindAddToCartButtons() {
        document.querySelectorAll('.add-to-cart-button').forEach(button => {
            button.removeEventListener('click', handleAddToCart);
            button.addEventListener('click', handleAddToCart);
        });
    }

    function handleAddToCart(event) {
        const form = event.currentTarget.closest('.variant-form');
        if (form) return;
        event.preventDefault();
        const productId = event.currentTarget.getAttribute('data-product-id');
        if (!productId) return;
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: productId, quantity: 1 })
        }).then(() => updateCart().then(openCartDrawerNow));
    }

    function bindVariantForms() {
        document.querySelectorAll('.variant-form').forEach(form => {
            form.removeEventListener('submit', handleVariantFormSubmit);
            form.addEventListener('submit', handleVariantFormSubmit);
        });
    }

    function handleVariantFormSubmit(event) {
        event.preventDefault();
        const form = event.currentTarget;
        const select = form.querySelector('select');
        const variantId = select ? select.value : null;
        if (!variantId) return;
        const button = form.querySelector('button');
        if (button) {
            button.disabled = true;
            button.innerHTML = `<div class='cart-spinner'></div>`;
        }
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(() => updateCart().then(openCartDrawerNow))
        .finally(() => {
            if (button) {
                button.disabled = false;
                button.innerHTML = 'Add to Cart';
            }
        });
    }

    function forceSelectWrapper() {
        document.querySelectorAll('.variant-form').forEach(form => {
            const select = form.querySelector('select');
            if (!select || select.closest('.select-wrapper')) return;
            const wrapper = document.createElement('div');
            wrapper.classList.add('select-wrapper');
            const span = document.createElement('span');
            span.classList.add('selected-text');
            span.textContent = select.options[select.selectedIndex].text.trim();
            select.parentNode.insertBefore(wrapper, select);
            wrapper.appendChild(span);
            wrapper.appendChild(select);
        });
    }

    function bindVariantSelectChange() {
        document.querySelectorAll('.variant-form select').forEach(select => {
            select.addEventListener('change', function () {
                const wrapper = select.closest('.select-wrapper');
                if (wrapper) {
                    const span = wrapper.querySelector('.selected-text');
                    if (span) span.textContent = select.options[select.selectedIndex].text.trim();
                }
            });
        });
    }

    // ─── CART ATTRIBUTES ─────────────────────────────────────────────────────
    async function updateCartAttributes() {
        const smsConsent = document.getElementById("sms-consent")?.checked ? "Yes" : "No";
        const contactNumber = document.getElementById("contact_number")?.value || "";
        const branch = document.getElementById("branch")?.value || "";
        const message = document.getElementById("message")?.value || "";
        const gateCode = document.getElementById("gate_code")?.value || "";
        const occasions = document.getElementById("occasions")?.value || "";
        const date = document.getElementById("date")?.value || "";
        const giftOrder = document.getElementById("gift-order-toggle")?.checked ? "Yes" : "No";
        const giftRecipientContact = document.getElementById("gift_recipient_contact")?.value || "";

        try {
            await fetch("/cart/update.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    attributes: {
                        "SMS Consent": smsConsent,
                        "Contact Number": contactNumber,
                        "Branch": branch,
                        "Occasions": occasions,
                        "message": message,
                        "date": date,
                        "GateCode": gateCode,
                        "Gift Order": giftOrder,
                        "Recipient Contact Number": giftRecipientContact,
                    }
                }),
            });
        } catch (err) {
            console.error("Error updating attributes:", err);
        }
    }

    document.addEventListener("change", (e) => {
        if (e.target.matches("#sms-consent, #contact_number, #branch, #occasions, #date, #message, #gate_code, #gift-order-toggle, #gift_recipient_contact")) {
            updateCartAttributes();
        }
    });

}
});
